/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import React, { useContext, useEffect } from 'react';
import { MyContext } from '../../Context/MyProvider';

const PayStack = ({ Amount, attributes }) => {

    const { setPaymentRes, setTransactionId, setPaymentLod } = useContext(MyContext);

    useEffect(() => {
        setPaymentLod(false);
    }, [])

    const handlePayment = () => {
        const localData = localStorage.getItem("LoginData");
        if (!localData) return;
        const parsedData = JSON.parse(localData);

        const script = document.createElement("script");
        script.src = "https://js.paystack.co/v1/inline.js";
        script.async = true;
        script.onload = () => {

            const paymentHandler = window.PaystackPop.setup({
                key: attributes?.split(",")[0],
                email: parsedData.email,
                amount: Amount * 100,
                currency: "NGN",
                callback: (response) => {
                    setPaymentRes("PaymentDone");
                    setTransactionId(response.transaction);
                },
                onClose: () => {
                    setPaymentRes("PaymentFaild");
                },
            });
            paymentHandler.openIframe();
        };
        document.body.appendChild(script);
    };

    return (
        <div className="h-[100%] flex justify-center items-center">
            <button style={{ margin: "0" }} className='button' onClick={handlePayment}>
                Pay with Paystack
            </button>
        </div>
    );
}

export default PayStack
/* jshint ignore:end */